import { render, staticRenderFns } from "./duets_list.vue?vue&type=template&id=7810495a&scoped=true&"
import script from "./duets_list.vue?vue&type=script&lang=js&"
export * from "./duets_list.vue?vue&type=script&lang=js&"
import style0 from "./duets_list.vue?vue&type=style&index=0&id=7810495a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810495a",
  null
  
)

export default component.exports